class FostrElement extends HTMLElement {
  constructor({name, version}) {
    super();
    this.name = name;
    this.version = version;
  }

  name() {
    return this.name;
  }

  version() {
    return this.version;
  }

  log(message, data) {
    console.log(`%c${message}`, 'color: #FFF; font-size: 17px; background: #000000; padding: 1rem;')
    if (data) console.log(data);
  }
}